<template>
    <data-view 
        :tableColumns="tableColumns" 
        :tableData="items" 
        :actionButtons="actionButtons" 
        titleKey="ClientName" 
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">
        <template #col-status="{ row }">
            <strong :class="row.status == true ? 'custom-success' : 'custom-warning'">
                {{ row.status == true ? $t('active') : $t('inactive') | capitalize }}
            </strong>
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'

const emit = defineEmits(['sortChanged', 'loadMore','details'])

const props = defineProps({
     items:{ type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'client_name', label: 'client', sortable:true},
    { key: 'bank_name', label: 'bank', sortable:true},
    { key: 'account_suffix', label: 'account', sortable:true},
    { key: 'currency', label: 'currency', sortable:false},
    { key: 'status', label: 'status', sortable:false}
])

const actionButtons = ref([
    { text: 'details', icon: 'FileTextIcon', color: 'primary', permissions:['IU HSBC REPORT'], onClick: row => emit('details', row) }
])

</script>

<style></style>
